export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6208.62a74254.jpg";